import { createSlice } from '@reduxjs/toolkit';
import { createUser, fetchUsers, deleteUser, fetchUserDetails, toggleUserStatus, fetchAllClients } from './actions';

const initialState = {
  users: [],
  selectedUser: null,
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
  },
  clients: [],
  clientsLoading: false,
  clientsError: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    clearSelectedUser: (state) => {
      state.selectedUser = null;
    },
  },
  extraReducers: (builder) => {
    // Create user
    builder.addCase(createUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createUser.fulfilled, (state, action) => {
      state.users.push(action.payload);
      state.loading = false;
    });
    builder.addCase(createUser.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });

    // Fetch users
    builder.addCase(fetchUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      state.users = action.payload.users;
      state.pagination = action.payload.pagination;
      state.loading = false;
    });
    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });

    // Delete user
    builder.addCase(deleteUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.users = state.users.filter(user => user.id !== action.payload);
      state.loading = false;
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });

    // Fetch user details
    builder.addCase(fetchUserDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchUserDetails.fulfilled, (state, action) => {
      state.selectedUser = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(fetchUserDetails.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });

    // Toggle user status
    builder.addCase(toggleUserStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toggleUserStatus.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(toggleUserStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder
      .addCase(fetchAllClients.pending, (state) => {
        state.clientsLoading = true;
        state.clientsError = null;
      })
      .addCase(fetchAllClients.fulfilled, (state, action) => {
        state.clients = action.payload;
        state.clientsLoading = false;
      })
      .addCase(fetchAllClients.rejected, (state, action) => {
        state.clientsError = action.payload;
        state.clientsLoading = false;
      });
  },
});

export const { clearSelectedUser } = usersSlice.actions;
export default usersSlice.reducer;
